import { ApiHelper } from './apiHelper';

export class RepairRequestApi {
    getRepairRequests(
        policyReference,
        token,
        successCallback = null,
        failureCallback = null
    ) {
        const query = encodeURI(`?policyreference=${policyReference}`);
        const dataUrl = '/api/repairrequest/getrepairrequests' + query;
        new ApiHelper().getDataSecure(
            dataUrl,
            token,
            successCallback,
            failureCallback
        );
    }

    save(repairRequests, token, callback = null, failureCallback = null) {
        const url = '/api/repairRequest';
        new ApiHelper().postDataWithResponseSecure(
            url,
            repairRequests,
            token,
            callback,
            failureCallback
        );
    }

    saveCosmetic(
        cosmeticRepairRequests,
        token,
        callback = null,
        failureCallback = null
    ) {
        const url = '/api/repairRequest/SaveCosmeticRepair';
        new ApiHelper().postDataWithResponseSecure(
            url,
            cosmeticRepairRequests,
            token,
            callback,
            failureCallback
        );
    }
    saveTyreRepair(
        tyreRepairRequests,
        token,
        callback = null,
        failureCallback = null
    ) {
        const url = '/api/repairRequest/SaveTyreRepair';
        new ApiHelper().postDataWithResponseSecure(
            url,
            tyreRepairRequests,
            token,
            callback,
            failureCallback
        );
    }
}
